module.exports = __webpack_public_path__ + "static/media/perk-2-new.e3a8eb2f.jpg";